module.exports = __webpack_public_path__ + "img/poster-1-sm.ff9abd0e.png";